<template>
	<!-- :style="{top:element.top,opacity:element.opacity}" -->
	<div class="historyList" v-if="historyList.length>0" >
		<div class="header">
			<div>搜索历史</div>
			<i class="icon el-icon-delete" title="清空本地记录" @click="emptyHistoryList"></i>
		</div>
		<div class="ul">
			<el-tag class="tag" type="info" size="mini" v-for="(item,index) in historyList" :key="index" @click="clickItem(item)">{{item}}</el-tag>
		</div>
	</div>
</template>

<script>
	let that
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'historyList',
		computed: {
			...mapGetters(['userInfo', 'api']) //获取
		},
		props: {
			confirm: {type:Function},
		},
		watch: {},
		data() {
			return {
				historyList:[],
				element:{
					top:'0px',
					opacity:0
				}
				
			}
		},
		mounted() {
			that = this
			if (JSON.parse(localStorage.getItem("historyList"))) {
				this.historyList = JSON.parse(localStorage.getItem("historyList"));
			}
		},
		methods: {
			clickItem(item){
				this.confirm(item)
			},
			setHistoryList(search_val){
				// 没有搜索记录，把搜索值push进数组首位，存入本地
				if (!this.historyList.includes(search_val)) {
					this.historyList.unshift(search_val);
					localStorage.setItem("historyList", JSON.stringify(this.historyList));
				}else{
					//有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
					let i =this.historyList.indexOf(search_val);
					this.historyList.splice(i,1)
					this.historyList.unshift(search_val);
					localStorage.setItem("historyList", JSON.stringify(this.historyList));
				}
			},
			//清空历史搜索记录
			emptyHistoryList(){
				localStorage.removeItem('historyList');
				this.historyList = [];
			},
		}
	}
</script>

<style lang="scss" scoped>
	.historyList{
		position: fixed;background-color: #fff;width: 330px;padding:10px 15px;box-sizing: border-box;margin-left: -1px;
		border-radius:0 0 5px 5px;border-top: 1px dashed #55aaff;
		.header{
			display:flex;align-items: center;justify-content: space-between;font-size: 14px;
			.icon{color: #ffaa7f;cursor: pointer;font-size: 16px;}
		}
		.ul{
			display: flex;flex-wrap: wrap;padding: 10px 0;
			.tag{
				cursor: pointer;margin-right: 10px;margin-bottom: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/historyList/historyList.vue